module.exports = __webpack_public_path__ + "img/visa.51c2253.svg";